import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ProfilePage = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [balance, setBalance] = useState(0);
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(true);
  const [showBalance, setShowBalance] = useState(true);
  const [uid, setUid] = useState('');
  const [availableBalance, setAvailableBalance] = useState(0);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const uid = localStorage.getItem("userid");
        const name = localStorage.getItem("name");
        const phone = localStorage.getItem("phone");
        
        setName(name || 'User');
        setUid(uid || '');
        setPhone(phone || '7470409407');

        if (uid) {
          const response = await fetch('https://singlewindowsecurities.com/rest3/wallet_api/' + uid);
          const responseJson = await response.json();
          const walletBalance = responseJson.wallet || 0;
          setBalance(walletBalance);
          setAvailableBalance(walletBalance);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        alert("Unable to load data");
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, []);

  const handleLogout = async () => {
    try {
      localStorage.clear();
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
      alert("Logout failed");
    }
  };

  const formatIndianCurrency = (num) => {
    if (!num && num !== 0) return '0.00';
    return parseFloat(num).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', background: '#0a0a0a' }}>
        <div className="text-center">
          <div className="spinner-border" style={{ color: '#D4AF37' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3" style={{ color: '#D4AF37' }}>Loading profile...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
    }}>
      {/* Header */}
      <div style={{
        background: 'rgba(10, 10, 10, 0.95)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div className="container py-3">
          <div className="d-flex align-items-center justify-content-between">
            <button 
              className="btn"
              onClick={() => navigate(-1)}
              style={{
                background: 'rgba(212, 175, 55, 0.1)',
                border: '1px solid rgba(212, 175, 55, 0.3)',
                borderRadius: '12px',
                width: '36px',
                height: '36px',
                color: '#D4AF37'
              }}
            >
              <i className="fa fa-arrow-left"></i>
            </button>
            
            <h5 className="fw-bold mb-0" style={{ color: '#D4AF37' }}>My Profile</h5>
            
            <div style={{ width: '36px' }}></div>
          </div>
        </div>
      </div>

      {/* Profile Card */}
      <div className="container mt-3">
        <div style={{
          background: 'linear-gradient(145deg, rgba(212, 175, 55, 0.15), rgba(184, 150, 12, 0.05))',
          borderRadius: '24px',
          padding: '24px',
          border: '1px solid rgba(212, 175, 55, 0.2)'
        }}>
          <div className="d-flex align-items-center mb-4">
            <div style={{
              width: '70px',
              height: '70px',
              background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
              borderRadius: '35px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '16px'
            }}>
              <i className="fa fa-person-fill" style={{ color: '#000', fontSize: '32px' }}></i>
            </div>
            <div className="flex-grow-1">
              <small style={{ color: '#D4AF37', letterSpacing: '1px' }}>WELCOME BACK,</small>
              <h5 className="mb-0 fw-bold" style={{ color: '#fff' }}>{name || 'Trader'}</h5>
              <small style={{ color: '#888' }}>Client ID: SWS00{uid}</small>
            </div>
          </div>

          <div style={{
            background: 'rgba(0, 0, 0, 0.3)',
            borderRadius: '16px',
            padding: '16px',
            marginTop: '8px'
          }}>
            <small style={{ color: '#D4AF37', letterSpacing: '1px', fontSize: '10px' }}>AVAILABLE BALANCE</small>
            <div className="d-flex align-items-center justify-content-between mt-1">
              <h2 className="fw-bold mb-0" style={{ color: '#D4AF37' }}>
                {showBalance ? `₹${formatIndianCurrency(availableBalance)}` : '••••••'}
              </h2>
              <button 
                className="btn btn-sm p-0"
                onClick={() => setShowBalance(!showBalance)}
                style={{ color: '#D4AF37' }}
              >
                <i className={`fa fa-eye${showBalance ? '' : '-slash'}`}></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Account Settings */}
      <div className="container mt-4">
        <small style={{ color: '#D4AF37', letterSpacing: '1px', fontSize: '11px' }} className="d-block mb-3">
          ACCOUNT SETTINGS
        </small>
        
        <div style={{
          background: 'rgba(20, 20, 20, 0.95)',
          borderRadius: '20px',
          border: '1px solid rgba(212, 175, 55, 0.15)',
          overflow: 'hidden'
        }}>
          <button 
            className="btn w-100 d-flex align-items-center p-3"
            onClick={() => navigate(`/kyc/${uid}`)}
            style={{
              borderBottom: '1px solid rgba(212, 175, 55, 0.1)',
              borderRadius: 0,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.05)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            <div style={{
              width: '40px',
              height: '40px',
              background: 'rgba(212, 175, 55, 0.15)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px'
            }}>
              <i className="fa fa-user" style={{ color: '#D4AF37', fontSize: '18px' }}></i>
            </div>
            <div className="flex-grow-1 text-start">
              <span className="fw-semibold" style={{ color: '#fff' }}>Account Profile</span>
            </div>
            <span style={{
              background: 'rgba(0, 200, 83, 0.15)',
              color: '#00C853',
              padding: '2px 10px',
              borderRadius: '20px',
              fontSize: '10px',
              fontWeight: 'bold'
            }}>
              Verified
            </span>
            <i className="fa fa-chevron-right" style={{ color: '#D4AF37', marginLeft: '8px' }}></i>
          </button>
          
          <button 
            className="btn w-100 d-flex align-items-center p-3"
            onClick={() => navigate('/bank')}
            style={{
              borderBottom: '1px solid rgba(212, 175, 55, 0.1)',
              borderRadius: 0,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.05)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            <div style={{
              width: '40px',
              height: '40px',
              background: 'rgba(212, 175, 55, 0.15)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px'
            }}>
              <i className="fa fa-building" style={{ color: '#D4AF37', fontSize: '18px' }}></i>
            </div>
            <div className="flex-grow-1 text-start fw-semibold" style={{ color: '#fff' }}>Bank & UPI Details</div>
            <i className="fa fa-chevron-right" style={{ color: '#D4AF37' }}></i>
          </button>
          
          <button 
            className="btn w-100 d-flex align-items-center p-3"
            onClick={() => navigate('/tradebook')}
            style={{
              borderRadius: 0,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.05)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            <div style={{
              width: '40px',
              height: '40px',
              background: 'rgba(212, 175, 55, 0.15)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px'
            }}>
              <i className="fa fa-list" style={{ color: '#D4AF37', fontSize: '18px' }}></i>
            </div>
            <div className="flex-grow-1 text-start fw-semibold" style={{ color: '#fff' }}>Transaction History</div>
            <i className="fa fa-chevron-right" style={{ color: '#D4AF37' }}></i>
          </button>
        </div>
      </div>

      {/* Support */}
      <div className="container mt-4 mb-4">
        <small style={{ color: '#D4AF37', letterSpacing: '1px', fontSize: '11px' }} className="d-block mb-3">
          SUPPORT
        </small>
        
        <div style={{
          background: 'rgba(20, 20, 20, 0.95)',
          borderRadius: '20px',
          border: '1px solid rgba(212, 175, 55, 0.15)',
          overflow: 'hidden'
        }}>
          <button 
            className="btn w-100 d-flex align-items-center p-3"
            onClick={() => navigate('/contact')}
            style={{
              borderBottom: '1px solid rgba(212, 175, 55, 0.1)',
              borderRadius: 0,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.05)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            <div style={{
              width: '40px',
              height: '40px',
              background: 'rgba(212, 175, 55, 0.15)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px'
            }}>
              <i className="fa fa-headset" style={{ color: '#D4AF37', fontSize: '18px' }}></i>
            </div>
            <div className="flex-grow-1 text-start fw-semibold" style={{ color: '#fff' }}>24x7 Customer Support</div>
            <i className="fa fa-chevron-right" style={{ color: '#D4AF37' }}></i>
          </button>
          
          <button 
            className="btn w-100 d-flex align-items-center p-3"
            onClick={() => navigate('/company')}
            style={{
              borderBottom: '1px solid rgba(212, 175, 55, 0.1)',
              borderRadius: 0,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.05)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            <div style={{
              width: '40px',
              height: '40px',
              background: 'rgba(212, 175, 55, 0.15)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px'
            }}>
              <i className="fa fa-info-circle" style={{ color: '#D4AF37', fontSize: '18px' }}></i>
            </div>
            <div className="flex-grow-1 text-start fw-semibold" style={{ color: '#fff' }}>About Us</div>
            <i className="fa fa-chevron-right" style={{ color: '#D4AF37' }}></i>
          </button>
          
          <button 
            className="btn w-100 d-flex align-items-center p-3"
            onClick={handleLogout}
            style={{
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 82, 82, 0.1)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            <div style={{
              width: '40px',
              height: '40px',
              background: 'rgba(255, 82, 82, 0.15)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px'
            }}>
              <i className="fa fa-sign-out" style={{ color: '#FF5252', fontSize: '18px' }}></i>
            </div>
            <div className="flex-grow-1 text-start fw-semibold" style={{ color: '#FF5252' }}>Sign Out</div>
            <i className="fa fa-chevron-right" style={{ color: '#FF5252' }}></i>
          </button>
        </div>
      </div>

      {/* Version Info */}
      <div className="container mb-4 text-center">
        <small style={{ color: '#555' }}>
          Version 2.0.0 | © 2026 Single Window Securities
        </small>
      </div>
    </div>
  );
};

export default ProfilePage;